import { GetRequest, PostRequest } from "../../plugins/https";
import { setCategory, getCategory } from "./action";
import { GET_CATEGORY, SET_CATEGORY } from "./actionType";

export const addCategory = (category) => async (dispatch) => {
  try {
    const res = await PostRequest("/category", category);
    dispatch(setCategory(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const getCategoryData = () => async (dispatch) => {
  try {
    const res = await GetRequest("/category");
    dispatch(getCategory(res.data));
  } catch (error) {
    console.error("Error getting category data : ", error);
  }
};

const initialState = {
  categoryData: [],
};

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY:
      return {
        ...state,
        categoryData:
          action.payload && action.payload.data
            ? action.payload.data
            : action.payload,
      };
    case GET_CATEGORY:
      return {
        ...state,
        categoryData:
          action.payload && action.payload.data
            ? action.payload.data
            : action.payload,
      };
    default:
      return state;
  }
};
